import { render, staticRenderFns } from "./BackendPaginatedSearch.vue?vue&type=template&id=9dac3f08&"
import script from "./BackendPaginatedSearch.vue?vue&type=script&lang=js&"
export * from "./BackendPaginatedSearch.vue?vue&type=script&lang=js&"
import style0 from "./BackendPaginatedSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports